export default __webpack_public_path__ + "static/media/tag-lightning.af95ca12.svg";